import React, { createContext, useContext, useState, useEffect } from 'react';
// import axios from 'axios';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import typography from '../theme/Typography';
import components from '../theme/Components';
import { shadows } from '../theme/Shadows';

import logoIcon from '../assets/images/logos/uhplLogo.jpeg';

const ConfigContext = createContext(null);

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};

export const ConfigProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    company_name: 'Uppal Group',
    company_logo: logoIcon,
    contact_email: 'admin@ubd.com',
    contact_phone: '+1 (555) 123-4567',
    address: 'Uppal Group Corporate Headquarters, Sector 5, Bangalore, India',
    footer_text: '© 2026 Uppal Group. All rights reserved.',
    primary_color: '#002147',
    accent_color: '#ffffff',
    secure_compliant_text: 'Encrypted administrative access for regional managers, employees and planners.'
  });
  const [loading, setLoading] = useState(true);

  const mapSettingsKeys = (data) => {
    if (!data) return {};
    return {
      company_name: data.companyName !== undefined ? data.companyName : (data.company_name || ''),
      company_logo: data.companyLogo !== undefined ? data.companyLogo : (data.company_logo || ''),
      contact_email: data.contactEmail !== undefined ? data.contactEmail : (data.contact_email || ''),
      contact_phone: data.contactPhone !== undefined ? data.contactPhone : (data.contact_phone || ''),
      address: data.address !== undefined ? data.address : '',
      footer_text: data.footerText !== undefined ? data.footerText : (data.footer_text || ''),
      primary_color: data.primaryColor !== undefined ? data.primaryColor : (data.primary_color || '#002147'),
      accent_color: data.accentColor !== undefined ? data.accentColor : (data.accent_color || '#ffffff'),
      secure_compliant_text: data.secureCompliantText !== undefined ? data.secureCompliantText : (data.secure_compliant_text || '')
    };
  };

  const fetchSettings = async () => {
    setLoading(false);
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  // Update HTML Document Title and Meta tags dynamically
  useEffect(() => {
    if (settings.company_name) {
      document.title = settings.company_name;
    }
  }, [settings.company_name]);

  const updateSettingsState = (newSettings) => {
    setSettings(mapSettingsKeys(newSettings));
  };

  // Build the Material UI theme dynamically using settings.primary_color
  const primaryColor = settings.primary_color || '#002147';
  const customTheme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: primaryColor,
        light: '#f3f4f6',
        dark: '#111111',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#6b7280',
        light: '#f9fafb',
        dark: '#374151',
        contrastText: '#ffffff',
      },
      background: {
        default: '#f8f9fa',
        paper: '#ffffff',
      },
      text: {
        primary: '#111827',
        secondary: '#4b5563',
      },
      divider: '#eaeaea',
    },
    shape: {
      borderRadius: 12,
    },
    shadows: shadows,
    typography: typography,
  });

  customTheme.components = components(customTheme);

  return (
    <ConfigContext.Provider value={{ settings, updateSettingsState, fetchSettings, loading }}>
      <MuiThemeProvider theme={customTheme}>
        {children}
      </MuiThemeProvider>
    </ConfigContext.Provider>
  );
};
